export const graphLayoutWrapper = `
  flex flex-col justify-start self-stretch items-stretch
  md:justify-between md:flex-row gap-3
`;

export const graphSideBySide = `
  flex justify-between gap-3 flex-row min-w-[250px]
  md:flex-col items-stretch
`;

export const graphContainer = `
  w-full md:min-h-[240px]
  flex flex-col self-stretch
`;

export const donutChartIcon = `text-ll-primary w-2/4 h-2/4`;

export const cardContainer = `min-h-36 h-full`;
